export enum DocumentAttributeKeys {
    Category = '_category',
    CreatedAt = '_created_at',
    DataSourceId = '_data_source_id',
    DocumentTitle = '_document_title',
    Format = '_file_type',
    SourceUri = '_source_uri',
    UpdatedAt = '_last_updated_at',
    Version = '_version',
    ViewCount = '_view_count',
}
